import { createUnorderedVerticalList } from '@vfde-brix/unordered-vertical-list';
import '@vfde-brix/unordered-vertical-list/dist/styles.css';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-unordered-vertical-list', createUnorderedVerticalList, NO_PATTERN_BUSINESS_LOGIC);
